import { Injectable, isDevMode, resolveForwardRef } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';
import { ParserService } from '../parser.service';
import { MultimediaManagerDaoService } from '../multimedia-manager-daos/multimedia-manager-dao.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { tap, map } from 'rxjs/operators';
import { MultimediaManagerDialogItem, MultimediaManagerDialogItemTypes } from '../multimedia-manager-dialog/multimedia-manager-dialog-item.model';

@Injectable({
  providedIn: 'root'
})
export class MultimediaManagerDialogLayoutService {

  private showDetailsListener = new Subject<MultimediaManagerDialogItem>();
  private hideDetailsListener = new Subject<MultimediaManagerDialogItem>();

  constructor(private parserService: ParserService,
              private multimediaManagerDaoService: MultimediaManagerDaoService,
              private userStorageService: UserStorageService) {
  }

  public showDetails(item) {
    this.showDetailsListener.next(item);
  }

  public listenShowDetails() {
    return this.showDetailsListener.asObservable();
  }
  public hideDetails() {
    this.hideDetailsListener.next();
  }

  public listenHideDetails() {
    return this.hideDetailsListener.asObservable();
  }

  public deleteItem(internalId) {
    return this.multimediaManagerDaoService.deleteItem(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId).pipe(
      tap(res => { if (isDevMode()) { console.dir(res); } }),
      map((res) => {
        const folders = null;
        return folders;
      })
    );
  }
  public saveElement(element) {
    return this.multimediaManagerDaoService.saveElement(
      this.userStorageService.getContext(),
      this.userStorageService.getLang(),
      this.userStorageService.getUDID(),
      element.data,
      element.name,
      element.type,
      element.destinyFolderId
  ).pipe(
      tap(res => { if (isDevMode()) { console.dir(res); } }),
      map((res) => {
        const item = Object.assign(new MultimediaManagerDialogItem(), this.parserService.parseItem(res['data']['element']));
        return item;
      })
    );
  }
  public updateElement(element) {
    return this.multimediaManagerDaoService.updateElement(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), element.internalId, element.data, element.name, element.type).pipe(
      tap(res => { if (isDevMode()) { console.dir(res); } }),
      map((res) => {
        const item = Object.assign(new MultimediaManagerDialogItem(), this.parserService.parseItem(res['data']['element']));
        return item;
      })
    );
  }
  public moveElements(elements, destinyFolderId, originFolderId) {
    return this.multimediaManagerDaoService.moveItems(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), elements, destinyFolderId, originFolderId).pipe(
      tap(res => { if (isDevMode()) { console.dir(res); } }),
      map((res) => {
        return res;
      })
    );
  }
  public getStorageOccupied() {
    return this.multimediaManagerDaoService.getStorageOccupied(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID()).pipe(
      tap(res => { if (isDevMode()) { console.dir(res); } }),
      map(res => res['data'])
    );
  }
}
